import { render, staticRenderFns } from "./LitePage2.vue?vue&type=template&id=2681a483&scoped=true"
import script from "./LitePage2.vue?vue&type=script&lang=js"
export * from "./LitePage2.vue?vue&type=script&lang=js"
import style0 from "./LitePage2.vue?vue&type=style&index=0&id=2681a483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681a483",
  null
  
)

export default component.exports